export const removeLineBreaks = (string: string, replacer?: string):string => {
    //via https://stackoverflow.com/questions/10805125/how-to-remove-all-line-breaks-from-a-string
    //replace with an empty string or with a replacer if presented
    return string.replace(/(\r\n|\n|\r)/gm, replacer ? replacer : '');
};